// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7fe4594d","453":"03346f77"}[chunkId] + ".chunk.js";
};